import { MessageCircle, Flame } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CallButton } from "@/components/CallButton";
import { WA, PRICES, INCLUDED, IMAGES } from "@/content";

export default function Offer() {
  return (
    <section id="lanzamiento" data-testid="offer-section" className="relative py-20 lg:py-28 bg-brand-cloud">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-brand-orange via-[#F4430F] to-brand-deep text-white shadow-[0_50px_120px_-40px_rgba(255,87,34,0.55)] grain">
            <div className="relative grid lg:grid-cols-[1.15fr_1fr] gap-10 p-8 sm:p-12 lg:p-16 items-center">
              <div>
                <span
                  data-testid="offer-limited-tag"
                  className="inline-flex items-center gap-2 rounded-full bg-white/15 border border-white/25 px-4 py-2 font-mono2 text-[10px] uppercase tracking-[0.22em]"
                >
                  <Flame className="h-3.5 w-3.5" />
                  Lanzamiento · Unidades limitadas
                </span>

                <h2
                  data-testid="offer-title"
                  className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.08] mt-6 text-balance"
                >
                  Llévate el EH8300 VET listo para trabajar
                </h2>

                <div className="mt-8 flex flex-wrap items-end gap-x-6 gap-y-3" data-testid="offer-pricing">
                  <span className="text-lg text-white/70 line-through" data-testid="offer-before-price">
                    {PRICES.before}
                  </span>
                  <span data-testid="offer-current-price" className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight">
                    {PRICES.now}
                    <span className="text-2xl font-bold align-top"> {PRICES.iva}</span>
                  </span>
                  <span
                    data-testid="offer-savings-chip"
                    className="rounded-full bg-brand-ink px-4 py-2 text-sm font-bold shadow-lg"
                  >
                    Ahorras {PRICES.savings}
                  </span>
                </div>

                <div className="mt-9 flex flex-wrap items-center gap-4">
                  <a
                    href={WA.offer}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="offer-whatsapp-cta"
                    className="btn-shine inline-flex items-center gap-2.5 rounded-full bg-brand-ink text-white font-bold text-[15px] px-8 py-4 hover:bg-black transition-colors duration-300"
                  >
                    <MessageCircle className="h-5 w-5" />
                    Quiero el precio de lanzamiento
                  </a>
                  <CallButton variant="dark" testid="offer-call-cta" />
                </div>
                <p className="mt-5 font-mono2 text-[11px] uppercase tracking-[0.18em] text-white/75" data-testid="offer-disclaimer">
                  Precios en pesos colombianos, más IVA · Oferta válida hasta agotar existencias
                </p>
              </div>

              <div className="relative">
                <img
                  src={IMAGES.scene}
                  alt="Excbio EH8300 VET instalado en un laboratorio de clínica veterinaria"
                  data-testid="offer-scene-image"
                  className="rounded-3xl border-4 border-white/30 shadow-2xl w-full object-cover aspect-[4/3]"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="relative grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/20 border-t border-white/20" data-testid="offer-included">
              {INCLUDED.map((inc, i) => (
                <div key={inc.title} className="bg-white/10 backdrop-blur-sm p-6 sm:p-7">
                  <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-white/70">
                    Incluido 0{i + 1}
                  </span>
                  <h3 className="font-display text-base font-bold mt-2">{inc.title}</h3>
                  <p className="text-sm text-white/80 mt-1.5 leading-relaxed">{inc.body}</p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
